/**
 * ChatLoader
 *
 * This class will load and append all the required scripts in a specific order
 *
 * @param {string} baseUrl - Chat base URL
 * @param {string} [env=production] - Chat environment. Usually 'production' or 'staging'
 * @param {chatLoadedCallback} [callback] - Callback to launch when all the scripts have been loaded successfully
 */
class ChatLoader {
  baseUrl
  chatEnv
  callback
  /** @type {string} */
  remoteScriptsVersion = '010'

  constructor(
    baseUrl,
    env = 'production',
    remoteScriptsVersion = null,
    callback = undefined
  ) {
    if (!baseUrl) {
      console.error('ChatLoader: Please provide the chat baseUrl')
      return
    }

    this.baseUrl = baseUrl
    this.chatEnv = env
    this.callback = callback

    if (remoteScriptsVersion) {
      this.remoteScriptsVersion = remoteScriptsVersion
    }

    this.init()
  }

  init() {
    if (document.body.classList.contains('a2a-chat-loaded')) {
      return
    }

    document.body.classList.add('a2a-chat-loaded')
    this.loadScripts('init')
  }

  loadScripts(action) {
    switch (action) {
      case 'init':
        this.loadStyles()
        this.loadEsw()
        break
      case 'loadedEsw':
        this.setChatDomainPersistanceSetting()
        this.loadChatProperties()
        break
      case 'loadedChatProperties':
        this.loadChatLoginWithPrechat()
        break
      case 'loadedChatLoginWithPrechat':
        if (this.callback && typeof this.callback === 'function') {
          this.callback()
        }
        break
      default:
        break
    }
  }

  loadEsw() {
    // Check if esw.min.js if already loaded
    if (
      window.embedded_svc ||
      document.querySelectorAll('script[src*="/esw.min.js"]').length > 0
    ) {
      this.loadScripts('loadedEsw')
      return
    }

    let script = document.createElement('script')
    script.id = 'a2a-chat-esw'
    script.type = 'text/javascript'
    script.src = `https://service.force.com/embeddedservice/5.0/esw.min.js`
    script.async = true
    script.onload = (e) => {
      this.loadScripts('loadedEsw')
    }
    document.body.appendChild(script)
  }

  setChatDomainPersistanceSetting() {
    if (window.embedded_svc) {
      window.embedded_svc.settings.storageDomain = 'a2a.it'
    }
  }

  loadChatProperties() {
    let script = document.createElement('script')
    script.id = 'a2a-chat-properties'
    script.type = 'text/javascript'
    script.src = `${this.baseUrl}/resource/${this.remoteScriptsVersion}/NewChatProperties`
    script.async = true
    script.onload = (e) => {
      this.loadScripts('loadedChatProperties')
    }
    document.body.appendChild(script)
  }

  loadChatLoginWithPrechat() {
    let script = document.createElement('script')
    script.id = 'a2a-chat-login-prechat'
    script.type = 'text/javascript'
    script.src = `${this.baseUrl}/resource/${this.remoteScriptsVersion}/SnippetWEB_PRECHAT`
    script.async = true
    script.onload = (e) => {
      this.loadScripts('loadedChatLoginWithPrechat')
    }
    document.body.appendChild(script)
  }

  loadStyles() {}
}

/**
 * Callback to launch when all the scripts have been loaded successfully
 *
 * @callback chatLoadedCallback
 */

export default ChatLoader
